import React, { useState } from "react";
import { all_routes } from "../../router/all_routes";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ProfileCard from "../common/profileCard";
import StudentSidebar from "../common/institutionSidebar";
import { Link } from "react-router-dom";
// import SettingsLinks from "./settingsLinks/settingsLinks";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import BackendImage from "../../../core/common/backendImage";
import CustomSelect from "../../../core/common/commonSelect";
import { Country, Gender, maritalStatus } from "../../../core/common/selectOption/json/selectOption";
import { DatePicker } from "antd";
// import SettingsModal from "./settingsModal/settingsModal";
import { useDispatch, useSelector } from "react-redux";
import { Institution, User } from "../../../core/types/types";
import axios from "axios";
import dayjs from 'dayjs';
import { updateUser } from "../../../core/redux/authSlice";
import apiInstance from "../../../utility/apiInstance";
import { stripNonNumeric } from "../../../utility/inputValidators";

const InstitutionProfile = () => {
    
    const dispatch = useDispatch();

    const user = useSelector((state: any) => state.auth.user);
    const institution = user?.institution;

    const [msg, setMsg] = useState({
        error: false,
        loading: false,
        text: ''
    });

    const [imagePreview, setImagePreview] = useState<string | null>(
        institution?.image?.url || null
    );
    const [imageUploading, setImageUploading] = useState(false);

    const [errorField, setErrorField] = useState('');

    const [formData, setFormData] = useState<Institution>({
        id: institution?.id || '',
        schoolName: institution?.schoolName || '',
        about: institution?.about || '',
        location: institution?.location || '',
        country: institution?.country || '',
        founded: institution?.founded || '',
        phoneNumber: institution?.phoneNumber || '',
        schoolType: institution?.schoolType || '',
        image: institution?.image?.id || institution?.image || null
    })

    const getModalContainer = () => {
        const modalElement = document.getElementById("add_assignment");
        return modalElement ? modalElement : document.body;
    };

    const handleInputChange = (
        e: any
    ) => {
        const { name } = e.target;
        let { value } = e.target;
        if (name === 'phoneNumber') {
            value = stripNonNumeric(value);
        }
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }))
        if (errorField === name) setErrorField('');
    };

    const validate = () => {
        let newErrors = '';
        let invalidField = '';

        if (!formData.schoolName?.trim()) {
            newErrors = "School name is required";
            invalidField = 'schoolName';
        } else if (!formData.country?.trim()) {
            newErrors = "Country is required";
            invalidField = 'country';
        }

        setErrorField(invalidField);

        setMsg({
            error: true,
            loading: false,
            text: newErrors
        })

        return newErrors.length === 0
    };

    const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const fd = new FormData();
        fd.append('file', file);
        fd.append('alt', 'Institution logo');
        try {
            setImageUploading(true);
            const res = await apiInstance.post('/api/media', fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            const media = res.data?.doc || res.data;
            setFormData(prev => ({ ...prev, image: media.id }));
            setImagePreview(media.url || null);
        } catch {
            setMsg({ error: true, loading: false, text: 'Image upload failed' });
        } finally {
            setImageUploading(false);
        }
    };

    const updateProfile = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validate()) return;

        setMsg({
            error: false,
            loading: true,
            text: ''
        });

        try {
            const response = await apiInstance.patch(`/api/institutions/${formData.id}`, formData);
            dispatch(updateUser({
                ...user,
                institution: response.data.doc
            }))
            setMsg({
                error: false,
                loading: false,
                text: 'Profile updated successfully!'
            });

        } catch (error: any) {
            setMsg({
                error: true,
                loading: false,
                text: error.message
            });
        }
    }

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* profile box */}
                    <ProfileCard />
                    {/* profile box */}
                    <div className="row">
                        {/* sidebar */}
                        <StudentSidebar />
                        {/* sidebar */}
                        <div className="col-lg-9">
                            <div className="mb-3">
                                <h5>Institution Profile</h5>
                            </div>
                            {/* <SettingsLinks /> */}
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={updateProfile}>
                                        {/* Institution Logo Upload */}
                                        <div className="mb-4">
                                            <label className="form-label fw-semibold">Institution Logo</label>
                                            <div className="d-flex align-items-center gap-3">
                                                {imagePreview && (
                                                    <BackendImage
                                                        src={imagePreview}
                                                        alt="Institution logo"
                                                        className="rounded"
                                                        width={80}
                                                        height={80}
                                                    />
                                                )}
                                                <div>
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="form-control form-control-sm"
                                                        onChange={handleImageUpload}
                                                        disabled={imageUploading}
                                                    />
                                                    <p className="fs-13 text-muted mb-0 mt-1">
                                                        PNG, JPG or SVG. Max 800×800px recommended.
                                                    </p>
                                                    {imageUploading && (
                                                        <span className="fs-13 text-info">Uploading...</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            School Name <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'schoolName' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="schoolName"
                                                            value={formData.schoolName}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'schoolName' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Location
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            defaultValue=""
                                                            name="location"
                                                            value={formData.location}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Founded 
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            defaultValue=""
                                                            name="founded"
                                                            value={formData.founded}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            School Type
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            defaultValue=""
                                                            name="schoolType"
                                                            value={formData.schoolType}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Country <span className="text-danger"> *</span>
                                                        </label>
                                                        <CustomSelect
                                                            options={Country}
                                                            className={`select d-flex ${errorField === 'country' ? 'is-invalid' : ''}`}
                                                            placeholder="Select"
                                                            name="country"
                                                            value={formData.country}
                                                            onChange={(selectedOption) => {
                                                                handleInputChange({
                                                                    target: {
                                                                        name: 'country',
                                                                        value: selectedOption.value
                                                                    }
                                                                });
                                                            }}
                                                        />
                                                        {errorField === 'country' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Contact Number
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            defaultValue=""
                                                            name="phoneNumber"
                                                            value={formData.phoneNumber}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                        Overview
                                                        </label>

                                                        <div
                                                        className="form-control"
                                                        style={{ minHeight: "120px" }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: formData.about || "",
                                                        }}
                                                        />
                                                    </div>
                                                    </div> */}

                                                <div className="col-md-12">
                                                    <button
                                                        className="btn btn-secondary rounded-pill"
                                                        type="submit"
                                                    >
                                                        Update Profile
                                                    </button>
                                                    {msg.loading &&
                                                        <span className="mt-3 fs-14 fw-normal d-flex align-items-center justify-content-center">Updating profile...</span>
                                                    }
                                                    {!msg.loading && !errorField &&
                                                        <span className={`mt-3 ${msg.error ? 'text-red' : ''} fs-14 fw-normal d-flex align-items-center justify-content-center`}>{msg.text}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {/* <div className="card mb-0">
                                <div className="card-body">
                                    <h5 className="fs-18 mb-3">Delete Account</h5>
                                    <h6 className="mb-1">
                                        Are you sure you want to delete your account?
                                    </h6>
                                    <p className="mb-3">
                                        Refers to the action of permanently removing a user's
                                        account and associated data from a system, service and
                                        platform.
                                    </p>
                                    <Link
                                        to="#"
                                        className="btn btn-secondary"
                                        data-bs-toggle="modal"
                                        data-bs-target="#delete_account"
                                    >
                                        Delete Account
                                    </Link>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <SettingsModal /> */}
        </>
    );
};

export default InstitutionProfile;
